import NextLink, { LinkProps } from "next/link";
import { ReactNode } from "react";

type Props = LinkProps & { children: ReactNode };

export function Link(props: Props) {
  return <NextLink {...props}>{props.children}</NextLink>;
}
